import React, {  } from 'react';
import Lcm_tour_m from './lcm_tour_mobile';
import Lcm_tour_w from './lcm_tour_web';

export default function Lcm_tour(){
    return (
        <div >
            <div className='hidden md:block'><Lcm_tour_w /></div>
            <div className='md:hidden'><Lcm_tour_m /></div>
        </div>
    )
}